import { render, staticRenderFns } from "./finish-dialog.vue?vue&type=template&id=b032c7e4"
import script from "./finish-dialog.vue?vue&type=script&lang=js"
export * from "./finish-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports